export const updateRootVariable = (variable: string, value: string) => {
  const r = document.querySelector(':root') as HTMLElement;
  if (!r) return;
  r?.style.setProperty(variable, value);
};
